import React from "react";
import "./Logo.css";

const Logo = () => {
  return (
    <h1 className="logo">
      Checker<span>s</span>
    </h1>
  );
};

export default Logo;
